import { useAuth } from "../context/AuthContext";
import { fmtDate, inr } from "../lib/format";
import { PageHeader, Panel } from "../components/Common";
import { ChangePasswordForm } from "../components/ChangePasswordForm";

export default function Profile() {
  const { user } = useAuth();
  const rows = [["Employee ID", user.employee_code], ["Email", user.email], ["Phone", user.phone], ["Department", user.department], ["Designation", user.designation],
    ["Date of joining", fmtDate(user.date_of_joining)], ["Annual CTC", user.ctc_annual ? inr(user.ctc_annual) : "—"], ["PAN", user.pan], ["UAN", user.uan], ["Bank A/c", user.bank_account], ["IFSC", user.bank_ifsc]];
  return (
    <div data-testid="profile-page">
      <PageHeader eyebrow="Account" title={user.name} subtitle={user.role === "admin" ? "HR / Admin" : user.designation || "Employee"} />
      <div className="grid lg:grid-cols-3 gap-6">
        <Panel title="Personal & statutory details" className="lg:col-span-2" testid="profile-details">
          <div className="grid sm:grid-cols-2 gap-x-8">
            {rows.map(([l, v]) => (
              <div key={l} className="flex justify-between py-2.5 border-b border-[#F0F0F2] text-sm gap-3"><span className="text-[#6E6E73]">{l}</span><span className="font-semibold text-right break-all">{v || "—"}</span></div>
            ))}
          </div>
          <p className="text-xs text-[#6E6E73] mt-4">Contact HR to update these details.</p>
        </Panel>
        <Panel title="Change password"><ChangePasswordForm /></Panel>
      </div>
    </div>
  );
}
